const $button = document.querySelector('.scroll-to-top');

const checkButton = () => {
  const visibleClassName = 'scroll-to-top--visible';
  const isVisible = $button.classList.contains(visibleClassName);

  if (window.pageYOffset > 450 && !isVisible) {
    $button.classList.add(visibleClassName);
  } else if (window.pageYOffset < 450 && isVisible) {
    $button.classList.remove(visibleClassName);
  }
};

if ($button) {
  $button.addEventListener('click', () => {
    window.scrollTo(window.pageXOffset, 0);
  });

  window.addEventListener('scroll', checkButton);
  checkButton();
}
